//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'EortcQLQC30',
  data () {
    return {
      form: {
        question1: '',
        question2: '',
        question3: '',
        question4: '',
        question5: '',
        question6: '',
        question7: '',
        question8: '',
        question9: '',
        question10: '',
        question11: '',
        question12: '',
        question13: '',
        question14: '',
        question15: '',
        question16: '',
        question17: '',
        question18: '',
        question19: '',
        question20: '',
        question21: '',
        question22: '',
        question23: '',
        question24: '',
        question25: '',
        question26: '',
        question27: '',
        question28: '',
        question29: '',
        question30: ''
      },
      dataList: [
        {value: '1', name: '没有'},
        {value: '2', name: '有一点'},
        {value: '3', name: '较多'},
        {value: '4', name: '非常多'}
      ],
      dataList2: [
        {value: '1', name: '1'},
        {value: '2', name: '2'},
        {value: '3', name: '3'},
        {value: '4', name: '4'},
        {value: '5', name: '5'},
        {value: '6', name: '6'},
        {value: '7', name: '7'}
      ],
      hasScore: false,
      disabled: false,
      descTxt1: '',
      descTxt2: '',
      descTxt3: ''
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            form[key] = Number(form[key])
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        self.logit = '...'
        return '...'
      } else {
        self.hasScore = true
        return {
          total: ((((form.question29 + form.question30) / 2 - 1) / 6) * 100).toFixed(0),
          num1: ((1 - ((form.question1 + form.question2 + form.question3 + form.question4 + form.question5) / 5 - 1) / 3) * 100).toFixed(0), // 躯体
          num2: ((1 - ((form.question6 + form.question7) / 2 - 1) / 3) * 100).toFixed(0), // 角色
          num3: ((1 - ((form.question21 + form.question25) / 2 - 1) / 3) * 100).toFixed(0), // 认知
          num4: ((1 - ((form.question21 + form.question22 + form.question23 + form.question24) / 4 - 1) / 3) * 100).toFixed(0), // 情绪
          num5: ((1 - ((form.question26 + form.question27) / 2 - 1) / 3) * 100).toFixed(0),
          num6: ((((form.question10 + form.question12 + form.question18) / 3 - 1) / 3) * 100).toFixed(0),
          num7: ((((form.question9 + form.question19) / 2 - 1) / 3) * 100).toFixed(0),
          num8: ((((form.question14 + form.question15) / 2 - 1) / 3) * 100).toFixed(0),
          num9: (((form.question8 - 1) / 3) * 100).toFixed(0),
          num10: (((form.question11 - 1) / 3) * 100).toFixed(0),
          num11: (((form.question13 - 1) / 3) * 100).toFixed(0),
          num12: (((form.question16 - 1) / 3) * 100).toFixed(0),
          num13: (((form.question17 - 1) / 3) * 100).toFixed(0),
          num14: (((form.question28 - 1) / 3) * 100).toFixed(0)
        }
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/EortcQLQC30.vue